import { render } from "./CompanyInfo.vue?vue&type=template&id=6f4a9470&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"

import "./CompanyInfo.vue?vue&type=style&index=0&id=6f4a9470&lang=scss&scoped=true"
import "./CompanyInfo.vue?vue&type=style&index=1&id=6f4a9470&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4a9470"]])

export default __exports__